export default function parseBookingSources(bookingSources) {
  //convert array to values react select can read
  let returnValue = [];
  for (var i = 0; i < bookingSources.length; i++) {
    returnValue.push({
      value: bookingSources[i].id,
      label: bookingSources[i].name + " (" + bookingSources[i].id + ")",
    });
  }
  return returnValue;
}
